import { type LatLng } from '~/_shared/types/latLng';
import { type MultiPolygon } from '~/_shared/types/polygon/polygon.types';

export const getLatLngsOfMultipolygonPoints = (multiPolygon: MultiPolygon): Readonly<LatLng>[] => (
  multiPolygon.reduce((all: Readonly<LatLng>[], polygon) => all.concat(polygon.path), [])
);
